import { render, staticRenderFns } from "./WarehouseManagement.vue?vue&type=template&id=b60389a2&scoped=true&"
import script from "./WarehouseManagement.vue?vue&type=script&lang=js&"
export * from "./WarehouseManagement.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseManagement.vue?vue&type=style&index=0&id=b60389a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60389a2",
  null
  
)

export default component.exports